module.exports = __webpack_public_path__ + "img/calendar.ec830944.svg";